import React from 'react';
import { type ImageCardVariantProps } from './image-card.variants';
import { ImageCardDefault } from './ImageCardDefault';
import { ImageCardFullWidth } from './ImageCardFullWidth';

export type ImageCardProps = {
  /** Image source URL */
  imageUrl: string;
  /** Alt text for the image */
  imageAlt: string;
  /** Optional styling for the image */
  imgClass?: string;
  /** Background color behind the image (default variant only; prefer over imgClass) */
  imageBackgroundColor?: 'neutral-50' | 'neutral-100' | 'white' | 'transparent';
  /** Aspect ratio of the image area (default variant only; prefer over imgClass) */
  imageAspect?: 'default' | 'video' | 'square';
  /** Defines the content area under the image and supports any valid React node (text, buttons, etc.) */
  children: React.ReactNode;
  /** Visual variant of the card */
  variant?: ImageCardVariantProps['variant'];
  /** Optional configuration props (e.g., className, aria-*) for styling and accessibility */
  className?: string;
};

export const ImageCard: React.FC<ImageCardProps> = ({
  imageUrl,
  imageAlt,
  imgClass,
  imageBackgroundColor,
  imageAspect,
  children,
  variant = 'default',
  className,
}) => {
  if (variant === 'full-width') {
    return (
      <ImageCardFullWidth
        imageUrl={imageUrl}
        imageAlt={imageAlt}
        imgClass={imgClass}
        className={className}
      >
        {children}
      </ImageCardFullWidth>
    );
  }

  return (
    <ImageCardDefault
      imageUrl={imageUrl}
      imageAlt={imageAlt}
      imgClass={imgClass}
      imageBackgroundColor={imageBackgroundColor}
      imageAspect={imageAspect}
      className={className}
    >
      {children}
    </ImageCardDefault>
  );
};
